module.exports = __webpack_public_path__ + "static/img/tou.eed8c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tou.png
// module id = 8Q4I
// module chunks = 1